import React from "react";
import SkeletonElement from "./SkeletonElement";
import SkeletonAnimation from "./SkeletonAnimation";

const SkeletonCard = ({ className }) => {
  return (
    <div className={`skeleton-card ${className}`}>
      <SkeletonElement type="img" />
      <div className="d-flex justify-content-between align-items-center">
        <SkeletonElement type="title w-75 me-3" />
        <SkeletonElement type="text" />
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <SkeletonElement type="text w-50 me-4" />
        <SkeletonElement type="text w-50 ms-3" />
      </div>
      <SkeletonAnimation />
    </div>
  );
};

export default SkeletonCard;
